const groupBy = (arr: any, criteria: any) => {
  const newObj = arr.reduce((acc: any, currentValue: any) => {
    if (!acc[currentValue[criteria]]) {
      acc[currentValue[criteria]] = [];
    }
    acc[currentValue[criteria]].push(currentValue);
    return acc;
  }, {});
  return newObj;
};

const getLocaleDayOfTheWeek = (dayOfTheWeek: string, lang: string) => {
  const baseDays = [
    new Date('01/04/1970') /* Sunday */,
    new Date('01/05/1970') /* Monday */,
    new Date('01/06/1970') /* Tuesday */,
    new Date('01/07/1970') /* Wednesday */,
    new Date('01/08/1970') /* Thursday */,
    new Date('01/09/1970') /* Friday */,
    new Date('01/10/1970') /* Saturday */,
  ];
  switch (dayOfTheWeek) {
    case 'Sunday':
      return baseDays[0].toLocaleDateString(lang, { weekday: 'long' });
    case 'Monday':
      return baseDays[1].toLocaleDateString(lang, { weekday: 'long' });
    case 'Tuesday':
      return baseDays[2].toLocaleDateString(lang, { weekday: 'long' });
    case 'Wednesday':
      return baseDays[3].toLocaleDateString(lang, { weekday: 'long' });
    case 'Thursday':
      return baseDays[4].toLocaleDateString(lang, { weekday: 'long' });
    case 'Friday':
      return baseDays[5].toLocaleDateString(lang, { weekday: 'long' });
    case 'Saturday':
      return baseDays[6].toLocaleDateString(lang, { weekday: 'long' });
    default:
      return null;
  }
};

const formatDaysToString = (dayList: string[], lang: string) => {
  const baseDays = [
    new Date('01/04/1970'),
    new Date('01/05/1970'),
    new Date('01/06/1970'),
    new Date('01/07/1970'),
    new Date('01/08/1970'),
    new Date('01/09/1970'),
    new Date('01/10/1970'),
  ];
  const baseLanguage = 'en';
  const stringResult = baseDays.reduce((prevVal, currVal, idx) => {
    if (
      dayList.includes(
        baseDays[idx].toLocaleDateString(baseLanguage, { weekday: 'long' })
      )
    ) {
      if (prevVal.lastIndexOf(',') === prevVal.length - 1) {
        return prevVal + currVal.toLocaleDateString(lang, { weekday: 'short' });
      }
      return `${prevVal}-${currVal.toLocaleDateString(lang, {
        weekday: 'short',
      })}`;
    }
    return `${prevVal},`;
  }, '');
  const weekdaySegments = stringResult.split(',').map((seg) => {
    const segArray = seg.split('-');
    return segArray.length > 1
      ? `${segArray[0]}-${segArray.slice(-1)}`
      : segArray[0];
  });
  return weekdaySegments.filter((segs) => segs).join(', ');
};

const unpackCategories = (categoryList: string[]) =>
  categoryList?.reduce((acc: string[], value: string) => {
    /*
      The first character of the string will (SHOULD) always be "/"
      so use substring() to clean this up before performing split
    */
    const categorySegments: string[] = value.substring(1).split('/');

    for (let x = 0; x < categorySegments.length; x += 1) {
      acc.push(`/${categorySegments.slice(0, x + 1).join('/')}`);
    }
    return acc;
  }, []);

const getAlertsModalButtonSlug = '/get-alerts';

function showLiveIndicator(liveItems: any, videoItem: any) {
  if (videoItem?.videoIds) {
    return liveItems.some((liveItem: any) => videoItem?.videoIds?.includes(liveItem.id));
  }
  return liveItems?.some((liveItem: any) => liveItem?.id === videoItem?.contentful_id);
}

function toTitleCase(str: string) {
  if (!str) return '';
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase(),
  );
}

function getMonthNumAndAbbrevArrByLocale(locale = 'en') {
  const year: number = new Date().getFullYear();
  const monthAbbrByLocale = [...Array(12).keys()].map((m) => {
    const monthAbbr: string = new Date(year, m).toLocaleDateString(locale, {
      month: 'short',
    });
    const monthObj = { [monthAbbr]: String(m + 1).padStart(2, '0') };
    return monthObj;
  });
  return monthAbbrByLocale;
}

const slugifyString = (str: string) => str.toLowerCase().replace(/[^A-Za-z0-9/\s]/g, '').replace(/[^A-Za-z0-9/]/g, '-');

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
export {
  capitalizeFirstLetter,
  groupBy,
  formatDaysToString,
  getAlertsModalButtonSlug,
  getLocaleDayOfTheWeek,
  getMonthNumAndAbbrevArrByLocale,
  showLiveIndicator,
  slugifyString,
  toTitleCase,
  unpackCategories,
};
